<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router/composables'

// swiper
import Swiper, { Autoplay } from 'swiper'

import { debounce } from 'lodash'
import Decimal from 'decimal.js'
import { useLoadingStore, useToastStore } from '@/stores'
import { isIOS } from '@/constants'

const route = useRoute()
const { $toast } = useToastStore()
const dataList = ref<any>([])
const currentLanguage = ref<any>('')
const currentActivityId = ref<any>('')
const { $showLoading, $hideLoading } = useLoadingStore()

// console.log(currentLanguage.value, currentActivityId.value, "11122333")
// 获取 Swiper 实例
Swiper.use([Autoplay]) // 关键！必须在初始化前调用
// 定义 slides 数据
const slides = ref([
  { id: 1, title: '茜様は年額プランを購入しました' },
  { id: 2, title: 'ミサキ様は年額プランを購入しました' },
  { id: 3, title: '綾瀬様は年額プランを購入しました' },
  { id: 4, title: '佐藤悟様は半年プランを購入しました' },
  { id: 5, title: '小原由紀子様は半年プランを購入しました' },
  { id: 6, title: '千秋様は半年プランを購入しました' },
  { id: 7, title: 'hirokisakamoto様はシーズンプランを購入しました' },
  { id: 8, title: 'ユウナ様はシーズンプランを購入しました' },
  { id: 9, title: '渚様はシーズンプランを購入しました' },
  { id: 10, title: '芽衣ちゃん様は年額プランを購入しました' },
])

const enSilids = ref([
  { id: 11, title: 'Charlotte has purchased a Annual Plan' },
  { id: 12, title: 'Alexander has purchased a Annual Plan' },
  { id: 13, title: 'Isabella has purchased a Annual Plan' },
  { id: 14, title: 'Matteo has purchased a Semi-Annual Plan' },
  { id: 15, title: 'Aurora has purchased a Semi-Annual Plan' },
  { id: 16, title: 'Amelia has purchased a Semi-Annual Plan' },
  { id: 17, title: 'Isla has purchased a Quarterly Plan' },
  { id: 18, title: 'Talara has purchased a Quarterly Plan' },
  { id: 19, title: 'Lowanna has purchased a Quarterly Plan' },
  { id: 20, title: 'Jarrah has purchased a Annual Plan' },
])

const currentSlides = computed(() => {
  const languageMap: Record<string, any[]> = {
    ja: slides.value,
    en: enSilids.value,
  }
  return languageMap[route.query.currentLanguage as string] || []
})

const mySwiper = ref<any>(null)
function initSwiper() {
  // 初始化 Swiper 实例
  mySwiper.value = new Swiper('.swiper-container', {
    // 配置选项
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    allowTouchMove: false,
  })
}

const currentDiscountObj = ref<any>({
  subscribe_0003: {},
  subscribe_0004: {},
  subscribe_0005: {},
})

// 扩展 Window 接口以支持 webkit.messageHandlers
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        notification?: {
          postMessage: (message: string) => void
        }
      }
    }
    jsYouShort?: {
      startPurchase: (message: string) => void
    }
    displayJSON?: (data: any) => void // 修改为函数类型
    paymentCallback?: (result: { code: number; message: string }) => void
    onDataReceived?: (data: any) => void // 新增属性
  }
}

const priceList = ref<any>({
  subscribe_0003: 9000,
  subscribe_0004: 14980,
  subscribe_0005: 23980,
})

// 拉起原生支付-节流
const handlePay = debounce((productId: string) => {
  const message = {
    webActiveType: 'pay',
    price: priceList.value[productId] ? new Decimal(priceList.value[productId]).times(100).toNumber() : '',
    webActiveProductId: productId ?? '', // 商品ID
    activityId: currentActivityId.value ?? '', // 活动ID
    discountId: currentDiscountObj.value[productId].discountId ?? '', // 优惠券ID
    discountPrice: currentDiscountObj.value[productId].productPrice ? new Decimal(currentDiscountObj.value[productId].productPrice).times(100).toNumber() : '', // 配置的优惠价格
    discountCycle: 1, // 优惠周期
    discountOrderAmount: currentDiscountObj.value[productId].productOriginPrice ? new Decimal(currentDiscountObj.value[productId].productOriginPrice).times(100).toNumber() : '', // 实际优惠价格
  }

  if (isIOS) {
    if (window.webkit?.messageHandlers?.notification)
      window.webkit?.messageHandlers?.notification?.postMessage(JSON.stringify(message))
    else
      $toast('当前环境不支持 window.webkit')
  }
  else {
    if (window.jsYouShort?.startPurchase)
      window.jsYouShort?.startPurchase(JSON.stringify(message))
    else
      $toast('当前环境不支持 window.jsYouShort')
  }
}, 800)

const disocuntUnit = ref('')
// 获取IOS/Andriod数据
function getData() {
  // 提取字母部分
  window.onDataReceived = (data: any) => {
    try {
      $showLoading()
      dataList.value = data.products
      // eslint-disable-next-line no-console
      console.log(data, 'dataList------')
      // 找数据
      if (dataList.value.length > 0) {
        setTimeout(() => {
          $hideLoading()
        }, 1000)
        dataList.value.forEach((item: any) => {
          if (item.productId === 'subscribe_0003')
            currentDiscountObj.value.subscribe_0003 = item
          else if (item.productId === 'subscribe_0004')
            currentDiscountObj.value.subscribe_0004 = item
          else if (item.productId === 'subscribe_0005')
            currentDiscountObj.value.subscribe_0005 = item
        })

        if (dataList.value.length > 0 && dataList.value[0].productOriginPrice) {
          const letterPart = dataList.value[0].productOriginPrice.replace(/[0-9,',','.']/g, '')
          disocuntUnit.value = letterPart
          // console.log(letterPart, "letterPart")
        }

        if (currentDiscountObj.value.subscribe_0003.productPrice || currentDiscountObj.value.subscribe_0003.productOriginPrice) {
          currentDiscountObj.value.subscribe_0003.productPrice = currentDiscountObj.value.subscribe_0003.productPrice?.replace(',', '').replace(/[^\d.]/g, '')
          currentDiscountObj.value.subscribe_0003.productOriginPrice = currentDiscountObj.value.subscribe_0003.productOriginPrice?.replace(',', '').replace(/[^\d.]/g, '')
        }

        if (currentDiscountObj.value.subscribe_0004.productPrice || currentDiscountObj.value.subscribe_0004.productOriginPrice) {
          currentDiscountObj.value.subscribe_0004.productOriginPrice = currentDiscountObj.value.subscribe_0004.productOriginPrice?.replace(',', '').replace(/[^\d.]/g, '')
          currentDiscountObj.value.subscribe_0004.productPrice = currentDiscountObj.value.subscribe_0004.productPrice?.replace(',', '').replace(/[^\d.]/g, '')
        }

        if (currentDiscountObj.value.subscribe_0005.productPrice || currentDiscountObj.value.subscribe_0005.productOriginPrice) {
          currentDiscountObj.value.subscribe_0005.productOriginPrice = currentDiscountObj.value.subscribe_0005.productOriginPrice?.replace(',', '').replace(/[^\d.]/g, '')
          currentDiscountObj.value.subscribe_0005.productPrice = currentDiscountObj.value.subscribe_0005.productPrice?.replace(',', '').replace(/[^\d.]/g, '')
        }

        // console.log(currentDiscountObj.value)
      }
      else {
        setTimeout(() => {
          $hideLoading()
        }, 1000)
      }
    }
    catch {
      $hideLoading()
    }
  }
}

onMounted(async () => {
  currentLanguage.value = route.query.currentLanguage
  currentActivityId.value = route.query.activityId
  getData()
  initSwiper()
  // window.localStorage.removeItem('DEBUG')
})

onBeforeUnmount(() => {
  if (mySwiper.value)
    mySwiper.value.destroy(true, true)
})

const localeMap: Record<string, string> = {
  ja: 'ja-JP',
  en: 'en-US',
  // 可以根据需要添加更多语言
}

const currentLocale = computed(() => localeMap[currentLanguage.value] || 'en-US')

// 计算千分位
function formatNumber(num: number | string): string {
  if (num)
    return Number(num).toLocaleString(currentLocale.value)
  else
    return '--'
}

// 计算属性，简化模板中的逻辑
// const currencySymbol = computed(() => {
//   return currentLanguage.value === 'ja' ? '¥' : currentLanguage.value === 'en' ? '$' : ''
// })
// 每天平均
function everyDayCount(day: number, disCount: number) {
  if (day > 0 && disCount > 0) {
    const everyPrice = (disCount / day).toFixed(2)
    if (Number(everyPrice) < 10)
      return everyPrice
    else
      return Math.floor(Number(everyPrice))
  }
  else {
    return '--'
  }
}
// 算折扣
function percentNumber(discount: number, originPrice: number) {
  if (discount > 0 && originPrice > 0)
    return Math.floor((1 - (discount / originPrice)) * 100) > 0 ? Math.floor((1 - (discount / originPrice)) * 100) : 0
  else
    return '--'
}
// 计算折扣
function formatOff(originPrice: number, discount: number) {
  if (discount && originPrice && discount > 0 && originPrice > 0)
    return (originPrice - discount > 0) ? formatNumber(originPrice - discount) : 0
  else
    return '--'
}
</script>

<template>
  <div class="main">
    <div class="w-full active-head">
      <img v-if="currentLanguage === 'ja'" src="@/assets/active-head-bg.png" alt="" class="w-full h-full">
      <img v-if="currentLanguage === 'en'" src="@/assets/active-head-bg-en.png" alt="" class="w-full h-full">
    </div>
    <!-- 必须保持这个结构 -->
    <div class="notice-box relative">
      <!-- <div class="w-full h-34px fixed top-0 left-0 bg-#ffffff z-9999">121212</div> -->
      <div class="absolute left-0 top--8px">
        <img src="@/assets/laba-logo.png" alt="" class="w-34px h-34px">
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(slide) in currentSlides"
            :key="slide.id"
            class="swiper-slide"
          >
            {{ slide.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="numFont">
      <div class="relative w-full h-213px m-auto mb-20px bg-#480083 rounded-4 flex pl-12px pr-12px active-bg1">
        <div class="absolute right--12px top--16px discount-bg">
          <span v-if="currentLanguage === 'ja'">{{ disocuntUnit }}</span>
          <span v-if="currentLanguage === 'ja'" class="discountPercent">
            {{ formatOff(currentDiscountObj.subscribe_0003?.productOriginPrice, currentDiscountObj.subscribe_0003?.productPrice) }}</span>
          <span v-if="currentLanguage === 'en'" class="discountPercent">
            {{ percentNumber(currentDiscountObj.subscribe_0003?.productPrice, currentDiscountObj.subscribe_0003?.productOriginPrice) }}
          </span>
          <span v-if="currentLanguage === 'en' && currentDiscountObj.subscribe_0003?.productPrice && currentDiscountObj.subscribe_0003?.productOriginPrice" class="discountUnit">%</span>
          <br>
          <span class="discountOff">OFF</span>
        </div>
        <div class="absolute left-0 top-0">
          <img v-if="currentLanguage === 'ja'" src="@/assets/title_90.png" alt="vip" class="w-190px h-45px">
          <img v-if="currentLanguage === 'en'" src="@/assets/title_en_90.png" alt="vip" class="w-191px h-45px">
        </div>
        <div class="w-40 relative leftBox">
          <img v-if="currentLanguage === 'ja'" src="@/assets/vip_90.png" alt="vip">
          <img v-if="currentLanguage === 'en'" src="@/assets/vip_en_90.png" alt="vip">
        </div>
        <div class="w-60 relative rightBox">
          <div class="discount">
            <span class="discountPriceOriginUnit">{{ disocuntUnit }}</span>
            <span>{{ currentDiscountObj.subscribe_0003?.productOriginPrice ? formatNumber(currentDiscountObj.subscribe_0003?.productOriginPrice) : '--' }}</span>
          </div>
          <div class="discountOrigin mt--4px">
            <span class="discountPriceUnit">{{ disocuntUnit }}</span>
            <span class="discountAfterPrice">{{ currentDiscountObj.subscribe_0003?.productPrice > 0 ? formatNumber(currentDiscountObj.subscribe_0003?.productPrice) : '--' }}</span>
          </div>
          <div class="pay-btn" @click="handlePay('subscribe_0003')">
            <div v-if="currentLanguage === 'en'" class="pay-sub-btn-text pb-1px">
              Only {{ disocuntUnit + (everyDayCount(90, currentDiscountObj.subscribe_0003?.productPrice)) }} per day
            </div>
            <div v-if="currentLanguage === 'ja'" class="pay-sub-btn-text">
              一日わずか {{ disocuntUnit + (everyDayCount(90, currentDiscountObj.subscribe_0003?.productPrice)) }}
            </div>
            <span class="pay-order-btn">{{ currentLanguage === 'ja' ? '今すぐ購入' : currentLanguage === 'en' ? 'Order now' : '' }}</span>
          </div>
        </div>
      </div>
      <div class="relative w-full h-230px m-auto mb-20px bg-#480083 rounded-4 flex pl-16px pr-16px active-bg2">
        <div class="absolute left-0 top-0">
          <img v-if="currentLanguage === 'ja'" src="@/assets/title_180.png" alt="vip" class="w-171px h-45px">
          <img v-if="currentLanguage === 'en'" src="@/assets/title_en_180.png" alt="vip" class="w-210px h-45px">
        </div>
        <div class="w-40 relative leftBox">
          <img v-if="currentLanguage === 'ja'" src="@/assets/vip_180.png" alt="vip">
          <img v-if="currentLanguage === 'en'" src="@/assets/vip_en_180.png" alt="vip">
        </div>
        <div class="absolute right--12px top--16px discount-bg discount-bg2">
          <span v-if="currentLanguage === 'ja'">{{ disocuntUnit }}</span>
          <span v-if="currentLanguage === 'ja'" class="discountPercent">
            {{ formatOff(currentDiscountObj.subscribe_0004?.productOriginPrice, currentDiscountObj.subscribe_0004?.productPrice) }}
          </span>
          <span v-if="currentLanguage === 'en'" class="discountPercent">
            {{ percentNumber(currentDiscountObj.subscribe_0004?.productPrice, currentDiscountObj.subscribe_0004?.productOriginPrice) }}
          </span>
          <span v-if="currentLanguage === 'en' && currentDiscountObj.subscribe_0004?.productPrice && currentDiscountObj.subscribe_0004?.productOriginPrice" class="discountUnit">%</span>
          <br>
          <span class="discountOff">OFF</span>
        </div>
        <div class="w-60 relative rightBox">
          <div class="discount discountSecond">
            <span class="discountPriceOriginUnit">{{ disocuntUnit }}</span>
            <span class="">{{ currentDiscountObj.subscribe_0004?.productOriginPrice ? formatNumber(currentDiscountObj.subscribe_0004?.productOriginPrice) : '--' }}</span>
          </div>
          <div class="discountOrigin ml-10px mt--4px">
            <span class="discountPriceUnit">{{ disocuntUnit }}</span>
            <span class="discountAfterPrice">{{ currentDiscountObj.subscribe_0004?.productPrice ? formatNumber(currentDiscountObj.subscribe_0004?.productPrice) : '--' }}</span>
          </div>
          <div class="pay-btn pay-sub-btn" @click="handlePay('subscribe_0004')">
            <div v-if="currentLanguage === 'en'" class="pay-sub-btn-text pb-1px">
              Only {{ disocuntUnit + (everyDayCount(180, currentDiscountObj.subscribe_0004?.productPrice)) }} per day
            </div>
            <div v-if="currentLanguage === 'ja'" class="pay-sub-btn-text">
              一日わずか {{ disocuntUnit + (everyDayCount(180, currentDiscountObj.subscribe_0004?.productPrice)) }}
            </div>
            <span class="pay-order-btn">{{ currentLanguage === 'ja' ? '今すぐ購入' : currentLanguage === 'en' ? 'Order now' : '' }}</span>
          </div>
        </div>
      </div>
      <div class="relative w-full h-230px m-auto mb-20px bg-#480083 rounded-4 flex pl-16px pr-16px active-bg2">
        <div class="absolute left-0 top-0">
          <!-- <img src="@/assets/title_365.png" alt="vip" class="w-171px h-45px"> -->
          <img v-if="currentLanguage === 'ja'" src="@/assets/title_365.png" alt="vip" class="w-171px h-45px">
          <img v-if="currentLanguage === 'en'" src="@/assets/title_en_365.png" alt="vip" class="w-173px h-45px">
        </div>
        <div class="w-40 relative leftBox">
          <img v-if="currentLanguage === 'ja'" src="@/assets/vip_365.png" alt="vip">
          <img v-if="currentLanguage === 'en'" src="@/assets/vip_en_365.png" alt="vip">
        </div>
        <div class="absolute right--12px top--16px discount-bg discount-bg2">
          <span v-if="currentLanguage === 'ja'">{{ disocuntUnit }}</span>
          <span v-if="currentLanguage === 'ja'" class="discountPercent">
            {{ formatOff(currentDiscountObj.subscribe_0005?.productOriginPrice, currentDiscountObj.subscribe_0005?.productPrice) }}
          </span>
          <span v-if="currentLanguage === 'en'" class="discountPercent">
            {{ percentNumber(currentDiscountObj.subscribe_0005?.productPrice, currentDiscountObj.subscribe_0005?.productOriginPrice) }}
          </span>
          <span v-if="currentLanguage === 'en' && currentDiscountObj.subscribe_0005?.productPrice && currentDiscountObj.subscribe_0005?.productOriginPrice" class="discountUnit">%</span>
          <br>
          <span class="discountOff">OFF</span>
        </div>
        <div class="w-60 relative rightBox">
          <div class="discount discountSecond">
            <span class="discountPriceOriginUnit">{{ disocuntUnit }}</span>
            <span class="">{{ currentDiscountObj.subscribe_0005.productOriginPrice ? formatNumber(currentDiscountObj.subscribe_0005.productOriginPrice) : '--' }}</span>
          </div>
          <div class="discountOrigin ml-10px mt--4px">
            <span class="discountPriceUnit">{{ disocuntUnit }}</span>
            <span class="discountAfterPrice">{{ currentDiscountObj.subscribe_0005.productPrice ? formatNumber(currentDiscountObj.subscribe_0005.productPrice) : '--' }}</span>
          </div>
          <div class="pay-btn pay-sub-btn" @click="handlePay('subscribe_0005')">
            <div v-if="currentLanguage === 'en'" class="pay-sub-btn-text pb-1px">
              Only {{ disocuntUnit + (everyDayCount(365, currentDiscountObj.subscribe_0005.productPrice)) }} per day
            </div>
            <div v-if="currentLanguage === 'ja'" class="pay-sub-btn-text">
              一日わずか {{ disocuntUnit + (everyDayCount(365, currentDiscountObj.subscribe_0005.productPrice)) }}
            </div>
            <span class="pay-order-btn">{{ currentLanguage === 'ja' ? '今すぐ購入' : currentLanguage === 'en' ? 'Order now' : '' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentLanguage === 'ja'" class="activeRules">
      <div class="color-#fff ruleTitle">
        キャンペーン詳細
      </div>
      <div>1. 会員プランは自動更新されますが、いつでも解約可能です。</div>
      <div>2. ご不明点はアプリ内の「お問い合わせ」よりサポートまでご連絡ください。</div>
      <div>3. 本キャンペーンに関する最終判断はUniReelに帰属します。</div>
      <div>4. 開催期間：本日午前0時から2025年5月11日23時59分まで（日本時間）</div>
      <div>5. 割引率は、お住まいの国や地域の利用環境、料金設定、または通貨によって異なる場合があります。</div>
      <div>6. 本イベント及びキャンペーンは、Apple Inc及びApple関連会社、Google LCCは一切関係ありません。</div>
    </div>
    <div v-if="currentLanguage === 'en'" class="activeRules">
      <div class="color-#fff ruleTitle">
        Campaign Details
      </div>
      <div>1. Membership plans will automatically renew but can be canceled at any time.</div>
      <div>2. For inquiries, please contact support via "Contact Us" within the app.</div>
      <div>3. The final decision regarding this campaign belongs to UniReel.</div>
      <div>4. Event Period:From 00:00 today until 23:59 on May 11th,2025 (UTC-4)</div>
      <div>5. Please note that the discount rate may differ depending on the usage environment, pricing, or currency of your country or region.</div>
      <div>6. This event is not sponsored, endorsed, administered by or associated with Apple Inc., Google LLC.</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  width: 100vw;
  overflow-x:hidden;
  max-width: var(--var-max-body-width, 750px);
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  // background-color: #4C008D;
  background: linear-gradient( 180deg, #4C008C 0%, #1B002D 100%);
  // background: linear-gradient( 180deg, #18002B 0%, #140022 20%, #150240 51%, #150240 100%), #4C008D;
  :deep(.swiper-container) {
    height: 27px; /* 必须设置高度 */
    flex:1;
    text-align: center;
    overflow: hidden;
  }
  :deep(.swiper-wrapper){
    height: 27px;
    text-align: center;
  }
  :deep(.swiper-slide) {
    height: 27px!important;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #ffffff;
  }
  .active-head{
    height: 469px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.08); /* 向下的阴影 */
  }
}
.pageTitle{
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.gradient-text {
  font-size: 48px;
  font-weight: bold;
  background: linear-gradient(to bottom, #FF0000, #0000FF); /* 从上到下（红到蓝） */
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.numFont  {
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 20px;
  padding-left: 12px;
  padding-right: 12px;
}
.notice-box {
  width: 330px;
  height: 27px;
  background: rgba(26,0,45,0.42);
  border-radius: 7px;
  display: flex;
  margin: 0 auto;
  margin-top: 12px;
  margin-bottom: 22px;
}
.leftBox,.rightBox{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.leftBox img{
  margin-top: 20px;
}
.activeRules{
  font-weight: normal;
  font-size: 12px;
  color: #CAB3DD;
  line-height: 20px;
  padding-bottom: 89px;
  padding-top: 16px;
  padding-left: 12px;
  padding-right: 12px;
}
.ruleTitle{
  font-size: 14px;
}
.active-bg1{
  background-image: url('@/assets/active-bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.active-bg2{
  background-image: url('@/assets/active-bg2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pay-btn {
  width: 177px;
  height: 44px;
  line-height: 44px;
  margin-top: 10px;
  text-align: center;
  position: relative;
  background-image: url('@/assets/active-btn1.png');
  background-size: contain;
  &.pay-sub-btn{
    background-image: none;
    background: linear-gradient( 253deg, #F32FA5 0%, #DF005E 100%);
    border-radius: 36px;
  }
  .pay-sub-btn-text {
    position: absolute;
    right: -2px;
    top: -10px;
    font-size: 12px;
    color: #ffffff;
    line-height: 15px;
    text-align: left;
    min-width: 111px;
    height: 15px;
    background: #A724FF;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px 10px 10px 0px;
    backdrop-filter: blur(10px);
  }
}
.rightBox {
  margin-left: 15px;
}
.rightBox .discount {
  font-size: 14px;
  color: #B680E6;
  text-decoration: line-through;
  margin-top: 20px;
  // font-family: LINESeedJPApp_OTF, LINESeedJPApp_OTF;
  &.discountSecond{
    margin-top: 40px;
    margin-left: 10px;
  }
}
.rightBox .discountOrigin {
  font-size: 36px;
  color: #FFD533;
}
.discount-bg{
  width: 92px;
  height: 92px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #FF5600;
  line-height: 17px;
  padding-top: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('@/assets/discount-bg1.png');
  transform: rotate(25deg);
  &.discount-bg2{
    color: #FFC935;
    background-image: url('@/assets/discount-bg2.png');
  }
}
.discountPercent {
  font-size: 22px;
  display: inline-block;
  // font-family: LINESeedJPApp_OTF, LINESeedJPApp_OTF;
}
.discountOff {
  font-size: 14px;
}
.discountUnit{
  font-size: 12px;
}
.discountPriceUnit{
  font-weight: normal;
  font-size: 12px;
  color: #FFD933;
}
.discountPriceOriginUnit{
  font-weight: normal;
  font-size: 12px;
  color: #B680E6;
}
.pay-order-btn {
  font-size: 17px;
  font-weight: 600;
}
.discountAfterPrice{
  font-weight: 500;
}
</style>
